import React from 'react';
import { ImagesProvider } from 'contexts/ImagesContext';
import ButtonBack from 'components/fragments/ButtonBack/ButtonBack';
const ButtonBackComponent = (props) => (
  <ImagesProvider
    intro={false}
    r={require.context(
      'components/fragments/ButtonBack/',
      true,
      /\.(png|jpe?g|svg|gif)$/
    )}
  >
    <ButtonBack {...props} />
  </ImagesProvider>
);

export default ButtonBackComponent;
